import { createSlice } from '@reduxjs/toolkit';

export interface StatementState {
  loading: boolean;
  loaderPercentage: number;
  error: any | null;
  initialStatement: any;
  jobStatus: string | null;
  statements: any[];
  nextEndDate: string;
  viewStatementError: any | null;
  viewStatementFilePath: any;
}

const initialState: StatementState = {
  loading: false,
  loaderPercentage: 0,
  error: null,
  initialStatement: null,
  jobStatus: null,
  statements: [],
  nextEndDate: '',
  viewStatementError: null,
  viewStatementFilePath: null,
};

const statementsSlice = createSlice({
  name: 'statements',
  initialState,
  reducers: {
    statementsRequest(state, action) {
      state.loading = true;
      state.error = null;
    },
    statementsFetched(state, action) {
      state.loading = false;
      state.statements = [
        ...state.statements,
        ...(action.payload?.monthlyStatements ?? []),
      ];
      state.nextEndDate = action.payload?.nextEndDate ?? '';
      state.error = null;
    },
    statementsFetchFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    initiateStatementRequest(state, action) {
      state.loading = true;
      state.error = null;
    },
    initiateStatementFetched(state, action) {
      state.initialStatement = action.payload;
      state.error = null;
    },
    initiateStatementFetchFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    jobStatementRequest(state, action) {
      state.loading = true;
      state.error = null;
      state.jobStatus = null;
    },
    jobStatementFetched(state, action) {
      state.jobStatus = action.payload ?? null;
      state.error = null;
    },
    jobStatementFetchFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    statementViewRequest(state, action) {
      state.loading = true;
      state.viewStatementError = null;
      state.viewStatementFilePath = null; //reset path
      state.loaderPercentage = 0;
    },
    setStatmentLoading(state, action) {
      state.loading = action.payload;
    },
    setStatementLoadPercentage(state, action) {
      state.loaderPercentage = action.payload;
    },
    statementViewFetched(state, action) {
      state.loading = false;
      state.viewStatementFilePath = action.payload;
      state.viewStatementError = null;
    },
    statementViewFetchFailed(state, action) {
      state.loading = false;
      state.viewStatementError = action.payload;
    },
    resetViewStatement(state) {
      state.viewStatementError = null;
      state.viewStatementFilePath = null;
      state.loaderPercentage = 0;
      state.loading = false;
      state.error = null;
      state.jobStatus = null;
      state.initialStatement = null;
    },
    resetStatementsSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  statementsRequest,
  statementsFetched,
  statementsFetchFailed,
  initiateStatementRequest,
  initiateStatementFetched,
  initiateStatementFetchFailed,
  jobStatementRequest,
  jobStatementFetched,
  jobStatementFetchFailed,
  statementViewRequest,
  statementViewFetched,
  statementViewFetchFailed,
  setStatmentLoading,
  setStatementLoadPercentage,
  resetViewStatement,
  resetStatementsSlice,
} = statementsSlice.actions;

export default statementsSlice.reducer;
